import { Component, OnInit } from '@angular/core';
import { CONSTANTS } from '../../constants';
import { Router } from '@angular/router';
import { LoginValidator } from './login.validator';
import { UntypedFormBuilder } from '@angular/forms';
import { Login } from '../../models/request/login';
import { LoginService } from '../../services/api/login.service';
import { JqueryUtils } from '../../utils/jquery.utils';

import { DataService } from '../../services/data.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  private login: Login;

  constructor(private dataService: DataService,
    private jq: JqueryUtils,
    private router: Router,
    public validator: LoginValidator,
    private formBuilder: UntypedFormBuilder,
    private notificationService: NotificationService,
    private loginService: LoginService) {
    this.login = new Login();
    this.validator.createForm(this.formBuilder);
  }

  ngOnInit(): void {
    this.validator.submitted = false;
  }

  openAlert() {
    this.jq.openModal('delProductModal');
  }

  doLogin() {

    sessionStorage.clear();

    if (!this.validator.isValid()) { return }
    this.login.username = this.validator.loginForm.value.username;
    this.login.password = this.validator.loginForm.value.password;
    this.loginService.doLogin(this.login).subscribe((response: any) => {
      if (response.response_code == 1000) {
        this.validator.submitted = false;
        sessionStorage.setItem(CONSTANTS.COOKIE.EMAIL, response.user.email);
        sessionStorage.setItem(CONSTANTS.COOKIE.HEADER_TOKEN, response.token);
        sessionStorage.setItem(CONSTANTS.COOKIE.IS_ADMIN, response.admin);
        sessionStorage.setItem(CONSTANTS.COOKIE.PHONE, response.user.phone);
        sessionStorage.setItem(CONSTANTS.COOKIE.USERNAME, response.user.full_name);
        sessionStorage.setItem(CONSTANTS.COOKIE.USER_ID, response.user._id);

        this.dataService.saveLiveSocketDetails(response.socket_conn);

        this.notificationService.showAlert(CONSTANTS.SUCCESS, 'Signed in successfully');
        if (response.admin) {
          this.router.navigate(['/tah', 'users']);
        } else {
          this.router.navigate(['/client', 'strategy']);
        }
      }
    });
  }

  openTermsAndConditions() {
    this.jq.openModal('termsAndConditionsModal');
  }
}
